import React, { useState, useEffect } from 'react';
import { GridView, SimpleView } from '@digital/ui';

import {
  CrfTipoAgrupador,
  getAllDisciplinas,
  getAllTipos,
  createDisciplina,
  createTipo,
  updateDisciplina,
  updateTipo,
  deleteDisciplina,
  deleteTipo,
} from '@app/api/crf/acronimo/Agrupador/tipoAgrupador';
import {
  CrfAcronimoAgrupador,
  getAllAcronimosAgrupador,
  createCrfAcronimoAgrupador,
  updateCrfAcronimoAgrupador,
  deleteCrfAcronimoAgrupador,
} from '@app/api/crf/acronimo/Agrupador/acronimosAgrupador';

import CRFTipoAgrupador from './TipoAgrupador';
import CRFAcronimoAgrupadorTable from './AcronimoAgrupadorTable';

const CRFAcronimoAgrupador = () => {
  const [acronimos, setAcronimos] = useState<CrfAcronimoAgrupador[]>();
  const [disciplinas, setDisciplinas] = useState<CrfTipoAgrupador[]>();
  const [tipos, setTipos] = useState<CrfTipoAgrupador[]>();
  const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

  const fetchData = () => {
    const getDisciplinas = async () => {
      const result = await getAllDisciplinas();
      if (result) setDisciplinas(result);
    };

    const getTipos = async () => {
      const result = await getAllTipos();
      if (result) setTipos(result);
    };

    const getAcronimosAgrupador = async () => {
      const result = await getAllAcronimosAgrupador();
      if (result) setAcronimos(result);
    };

    getDisciplinas();
    getTipos();
    getAcronimosAgrupador();
  };

  useEffect(() => fetchData(), []);
  useEffect(() => fetchData(), [shouldUpdate]);

  return (
    <SimpleView>
      <GridView noform>
        {true && (
          <>
            <CRFAcronimoAgrupadorTable
              titulo="Acrônimos"
              data={acronimos || []}
              disciplinas={(disciplinas && disciplinas.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              tipos={(tipos && tipos.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              handleCreate={createCrfAcronimoAgrupador}
              handleUpdate={updateCrfAcronimoAgrupador}
              handleDelete={deleteCrfAcronimoAgrupador}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <CRFTipoAgrupador
              titulo="Disciplina"
              label="Nome da Disciplina"
              data={disciplinas || []}
              handleCreate={createDisciplina}
              handleUpdate={updateDisciplina}
              handleDelete={deleteDisciplina}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <CRFTipoAgrupador
              titulo="Tipo"
              label="Nome do Tipo"
              data={tipos || []}
              handleCreate={createTipo}
              handleUpdate={updateTipo}
              handleDelete={deleteTipo}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />
          </>
        )}
      </GridView>
    </SimpleView>
  );
};

export default CRFAcronimoAgrupador;
